import React from "react";
import SuspenseWrapper from "../../component/SuspenseWrapper";
const Otherdocumentreport = React.lazy(() => import("@/pages/otherDocumentReport/OtherDocumentReport"));
const BankAccountReport = React.lazy(() => import("@/pages/otherDocumentReport/BankAccountUpdate"));


const OtherDocumentRouter = [
  {
    path: "otherdocumentreport",
    element: (
      <SuspenseWrapper>
        <Otherdocumentreport />
      </SuspenseWrapper>
    ),
  },
  {
    path: "accountupdatereport",
    element: (
      <SuspenseWrapper>
        <BankAccountReport />
      </SuspenseWrapper>
    ),
  },

];

export default OtherDocumentRouter;
